import Head from "next/head";

export const NoIndex = () => (
  <Head>
    <meta key="robots" content="none" />
  </Head>
);
